import { Link } from "react-router-dom";
import { TEAM } from "../../data/content";
import { TEAM_PHOTOS } from "../../data/teamPhotos";
import useReveal from "../shared/useReveal";
import "./TeamHome.css";
import "./HomeSections.css";

export default function TeamHome() {
  const ref = useReveal();

  return (
    <section className="section alt" id="team-home">
      <div className="container" ref={ref}>
        <div className="home-section-head section-head pm-reveal">
          <span className="kicker">Meet Our Team</span>
          <h2>Real experts. Not a chatbot.</h2>
          <p className="sub">
            CFA, CA, and CS advisors guiding investment and business decisions
            under one roof.
          </p>
        </div>
        <div className="home-team-grid pm-stagger">
          {TEAM.map((m) => {
            const photo = TEAM_PHOTOS[m.id];
            return (
              <div className="home-team-card pm-reveal" key={m.id}>
                {photo ? (
                  <img
                    className="home-tphoto"
                    src={photo}
                    alt={m.name}
                    width={104}
                    height={104}
                    loading="lazy"
                  />
                ) : (
                  <div className="home-avatar" aria-hidden="true">
                    {m.initials}
                  </div>
                )}
                <h3>{m.name}</h3>
                <div className="home-team-role">{m.designation}</div>
                <p>{m.expertise}</p>
                {m.linkedin && (
                  <a
                    className="home-team-link"
                    href={m.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    LinkedIn ↗
                  </a>
                )}
              </div>
            );
          })}
        </div>
        <div className="home-team-foot pm-reveal">
          <Link to="/team" className="btn btn-ghost">
            Meet the full team →
          </Link>
        </div>
      </div>
    </section>
  );
}
